import { SortOrder } from "constants/index";
import { FormikFormProps } from "formik";
import { Options } from "hooks/useTrialApi.hook";
import { UseMutationResult } from "@tanstack/react-query";
import { FieldConfig } from "@/utils/form.utils";

interface Queries {
  options: Options;
  setOptions: (options: Options) => void;
  createParticipant: UseMutationResult<void, unknown, any, unknown>;
}

export const useHelpers = (
  queries: Queries,
  trialId: string,
  handleClose: () => void
) => {
  const createNewParticipant = async (values: FormikFormProps) => {
    const payload = { trialId: trialId, ...values };
    await queries.createParticipant.mutateAsync(payload);
    const options = {
      ...queries.options,
      skip: 0,
      order: `createdAt|${SortOrder.DESC}`,
      participants: true,
    };
    queries.setOptions(options);
    handleClose();
  };

  const handleSorting = async (order: string) => {
    const options = {
      ...queries.options,
      skip: 0,
      order,
    };
    queries.setOptions(options);
  };

  return { createNewParticipant, handleSorting };
};

export const filterParticipantFormFields = (
  fields: FieldConfig[],
  hasAdmin: boolean,
  typeFieldName: string
) => {
  return hasAdmin
    ? fields
    : fields.filter((field) => field.name !== typeFieldName);
};
